import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IBosApiDealerInfoData } from 'next-common';

interface DealerState {
  dealers: Record<string, IBosApiDealerInfoData>;
}

const initialState: DealerState = {
  dealers: {},
};

const dealerSlice = createSlice({
  name: 'dealer',
  initialState,
  reducers: {
    setDealer(state, action: PayloadAction<{ dealerId: string; dealer: IBosApiDealerInfoData }>) {
      state.dealers[action.payload.dealerId] = action.payload.dealer;
    },
  },
});

export const { setDealer } = dealerSlice.actions;
export default dealerSlice.reducer;
